var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: "",
        centered: true,
        footer: null,
        maskClosable: false,
        dialogClass: "global-campaign-modal-class",
        closable: false,
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-con", class: [_vm.lang] },
        [
          _c("a-icon", {
            staticClass: "warin-icon",
            attrs: { type: "exclamation-circle", theme: "filled" },
          }),
          _c("div", {
            staticClass: "tip-txt",
            domProps: { innerHTML: _vm._s(_vm.tipTxt) },
          }),
          _c(
            "a-button",
            {
              staticClass: "btn",
              attrs: { type: "primary" },
              on: { click: _vm.saveLinkedIn },
            },
            [_vm._v(_vm._s(_vm.$t("CampaignModalTipBtn")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }